import { AfterContentInit, AfterViewInit, Component, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/components/common/api';
import { GenericComponent } from './generic-component';
import { GenericService } from '../../../_services/generic-service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: "page-table",
    templateUrl: './page-table.component.html',
    inputs: ["title", "loadTableStr", "subtitle", "menu", "submenu", "portletTitle", "sortField", "rows", "paginator", "rowsPerPageOptions", "arrTable", "cols", "columnOptions", "item", "itemName", "genericform", "displayDialogAddEdit", "loading", "icon", "dialogTitle"],
    providers: [GenericService]
})


export class PageTableComponent extends GenericComponent implements AfterViewInit {
    loadTableStr: string = "";
    title: string = "";
    subtitle: string = "";
    menu: string = "";
    submenu: string = "";
    sortField: string = "";
    rows = 5;
    paginator: boolean;
    rowsPerPageOptions: number[] = [5, 10, 20, 50, 100];
    responsive: boolean = true;
    pageLinks: number = 3;
    cols: any[] = [];
    columnOptions: SelectItem[];
    item: any;
    itemName: string;
    dialogTitle: string = "";
    @ViewChild('dt') table;
    first = 0;
    lastpage = 1;

    constructor(private genericService: GenericService) {
        super(genericService);
    }
    

    ngOnInit() {
        if (this.loadTableStr != "")
            this.loadTable(this.loadTableStr);


    }
    ngAfterViewInit() {
        
    }

    goToPage(page: number): void {
        setTimeout(() => {
            this.table.first = (page - 1) * this.rows;
            this.lastpage = page;
            this.table.firstChange.emit(this.table.first);
        }, 0);
    }

    setColumnOttions() {
        this.columnOptions = [];
        for (let i = 0; i < this.cols.length; i++) {
            this.columnOptions.push({ label: this.cols[i].header, value: this.cols[i] });
        }
    }

    paginate(event) {

        console.log(event);
        this.first = event.first;// = Index of the first record
        this.rows = event.rows;// = Number of rows to display in new page
        this.lastpage =Math.floor(  event.first/this.rows)+1
        console.log(this.lastpage);
        ;
        //  event.pageCount = Total number of pages
    }


    updateTable(object: any, arrTable) {
        arrTable.push(object);
        this.arrTable = arrTable;

        this.onchange.emit(this.arrTable);
    //    Utils.log("after insert", arrTable, this.arrTable);


        this.displayDialogAddEdit = false;
        this.showMessageSuccess();
        this.cleanForm();
        this.goToPage(this.lastpage);
    }



}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/custom-component/page-table.component.ts